import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import Social from '../blocks/Social';
import ImageLoader from '../pieces/ImageLoader';
import { ROOT_DIR, LOCATION, DOMAIN } from '../../utils/Constants';
import SectionLoader from '../pieces/SectionLoader';
import ListItems from '../blocks/ListItems';
import PriorityListItems from '../blocks/PriorityListItems';

class SearchResults extends Component {
  state = {
    imageStatus: 'loading'
  }
  componentDidMount(){
    window.scrollTo(500, 0);
    this.doSearch(this.props.match.params.keyword);
    this.props.getPriorityList(this.props.match.params.keyword);
  }
  componentWillReceiveProps(nextProps){
    if(this.props.match.params.keyword !== nextProps.match.params.keyword){
      this.doSearch(nextProps.match.params.keyword);
      this.props.getPriorityList(this.props.match.params.keyword);
    }
  }
  
  doSearch = (keyword) => {
    this.props.doSearch(keyword);
  }
  handleImageLoaded = () => {
   this.setState({ imageStatus: 'loaded' }); 
  }
  handleImageErrored = () => {
    this.setState({ imageStatus: 'error' });
  }
  render(){
    const meta = {
      title: `― Find businesses, services and events on ${LOCATION}, Essex, UK, search our business directory ―`,
      description: `Business directory for ${LOCATION}, Essex, UK. Find local businesses, services and events.`,
      canonical: `http://www.${DOMAIN}/search/${this.props.match.params.keyword}`,
      meta: {
        keywords: `Search for ${this.props.match.params.keyword} on ${LOCATION}, Essex, United Kingdom, business listings, business directory, businesses`
      }
      
    };
    let resultText = 'results';
    let keyword = this.props.keyword;
    let resultsCount = this.props.list.length;
    let list = this.props.list;
    let count = this.props.searchCount + this.props.priorityList.length;
    let typeDir = keyword;

    if(count === 1){
      resultText = 'result';
    }
    
    return(
      <div>
        <DocumentMeta {...meta} />
        <div className="banner innerpage-banner">
          <h1 className="innerpage-heading no-margin">Search businesses on {LOCATION}</h1>
          <Social/>
          <ImageLoader
              imageStatus={this.state.imageStatus}
            />
          <picture>
              <source media="(min-width: 769px)" srcSet={`${ROOT_DIR}/assets/img/search-banner.jpg`}/>
              <source media="(max-width: 768px)" srcSet={`${ROOT_DIR}/assets/img/search-banner-mob.jpg`}/>
              <img 
                src={`${ROOT_DIR}/assets/img/search-banner.jpg`} 
                alt={`Businesses on ${LOCATION}`} 
                onLoad={this.handleImageLoaded}
                onError={this.handleImageErrored}
                />
            </picture>
            
        </div>
        <div className="page-content-wrapper">
          <div className="row">
            <div className="large-12 columns page-content">
              <p>{count} {resultText} for <span className="bold">"{keyword}"</span>:</p>
              {this.props.priorityList.length > 0 && 
                <PriorityListItems
                  priorityList={this.props.priorityList}
                />
              }
              {this.props.loadingList ?
              <SectionLoader/>
            :
              <ListItems
                list={list}
                typeDir={typeDir}
              />
            }


            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SearchResults;


// WEBPACK FOOTER //
// ./src/components/pages/SearchResults.js